import { render, staticRenderFns } from "./RegularListBuyBox.vue?vue&type=template&id=5f91f811&scoped=true"
import script from "./RegularListBuyBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegularListBuyBox.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RegularListBuyBox.vue?vue&type=style&index=0&id=5f91f811&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f91f811",
  null
  
)

export default component.exports